import { FC, ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';
import { BottomSheet } from 'src/components/BottomSheet';
import theme from 'src/utils/theme';
import * as S from './styles';

type OptionsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  contentLabel: string;
  'data-testid'?: string;
  children: ReactNode;
};

/** A centred modal on desktop and a bottom sheet on mobile. */
export const OptionsDialog: FC<OptionsDialogProps> = ({
  isOpen,
  onClose,
  contentLabel,
  'data-testid': testId,
  children,
}) => {
  const isMobile = useMediaQuery({ maxWidth: theme.sz.md });

  if (isMobile) {
    return (
      <BottomSheet isOpen={isOpen} onClose={onClose} contentLabel={contentLabel}>
        <S.Content $inSheet data-testid={testId}>
          {children}
        </S.Content>
      </BottomSheet>
    );
  }

  return (
    <S.Modal
      isOpen={isOpen}
      handleClose={onClose}
      contentLabel={contentLabel}
      shouldCloseOnEsc
      darkCloseIcon
    >
      <S.Content $inSheet={false} data-testid={testId}>
        {children}
      </S.Content>
    </S.Modal>
  );
};
